import _classCallCheck from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import ChatManagerInstance from "./ChatManager";
import BroadcastThreadManagerInstance from "./BroadcastThreadManager";
import BaseSession from "./BaseSession";
import FirebaseGlobalPresenceSession from "./FirebaseGlobalPresenceSession";
import * as log from "loglevel";

var GlobalPresenceSession = /*#__PURE__*/function (_BaseSession) {
  _inherits(GlobalPresenceSession, _BaseSession);

  function GlobalPresenceSession(userName, accessToken) {
    _classCallCheck(this, GlobalPresenceSession);

    return _possibleConstructorReturn(this, _getPrototypeOf(GlobalPresenceSession).call(this, userName, accessToken));
  }

  _createClass(GlobalPresenceSession, [{
    key: "getAPIRequestFirebaseAccessURL",
    value: function getAPIRequestFirebaseAccessURL() {
      return ChatManagerInstance.restApiURL + "/presence/" + this.userName;
    }
  }, {
    key: "buildFirebaseSession",
    value: function buildFirebaseSession() {
      return new FirebaseGlobalPresenceSession(this.userName, this._id);
    }
  }, {
    key: "addToGlobalPresence",
    value: function addToGlobalPresence(addUserToGlobalPresenceNodeHandler) {
      this.firebaseSession.addUserToPresenceNode(function (error) {
        if (addUserToGlobalPresenceNodeHandler) {
          addUserToGlobalPresenceNodeHandler(error);
        }
      });
    }
  }, {
    key: "addToGlobalPresenceWithLocation",
    value: function addToGlobalPresenceWithLocation(location, addUserToGlobalPresenceNodeHandler) {
      this.firebaseSession.addUserToPresenceNodeWithLocation(location, function (error) {
        if (addUserToGlobalPresenceNodeHandler) {
          addUserToGlobalPresenceNodeHandler(error);
        }
      });
    }
  }, {
    key: "removeFromGlobalPresence",
    value: function removeFromGlobalPresence(removeFromGlobalPresenceHandler) {
      this.firebaseSession.removeUserFromPresenceNode(function (error) {
        if (removeFromGlobalPresenceHandler) {
          removeFromGlobalPresenceHandler(error);
        }
      });
    }
  }, {
    key: "removeFromGlobalPresenceWithLocation",
    value: function removeFromGlobalPresenceWithLocation(location, removeFromGlobalPresenceHandler) {
      this.firebaseSession.removeUserFromPresenceNodeWithLocation(location, function (error) {
        if (removeFromGlobalPresenceHandler) {
          removeFromGlobalPresenceHandler(error);
        }
      });
    }
  }, {
    key: "setGlobalRosterListener",
    value: function setGlobalRosterListener(externalGlobalRosterListener) {
      log.trace("attach global roster listener");
      this.firebaseSession.attachGlobalRosterListener(function (event) {
        log.trace("room roster event" + JSON.stringify(event));
        externalGlobalRosterListener(event);
      });
    }
  }, {
    key: "setGlobalRosterListenerWithLocation",
    value: function setGlobalRosterListenerWithLocation(location, externalGlobalRosterListener) {
      log.trace("attach global roster listener");
      this.firebaseSession.attachGlobalRosterListenerWithLocation(location, function (event) {
        log.trace("room roster event" + JSON.stringify(event));
        externalGlobalRosterListener(event);
      });
    }
  }, {
    key: "setGlobalEventsListener",
    value: function setGlobalEventsListener(externalGlobalEventsListener) {
      log.trace("attach global events listener");
      this.firebaseSession.attachGlobalEventsListener(function (event) {
        log.trace("global event" + JSON.stringify(event));
        externalGlobalEventsListener(event);
      });
    }
  }, {
    key: "setSystemLastEventListner",
    value: function setSystemLastEventListner(systemLastEventListener) {
      log.trace("attach system last event listener!");
      this.firebaseSession.attachSystemLastEventListener(function (event) {
        log.trace("system event" + JSON.stringify(event));
        systemLastEventListener(event);
      });
    }
  }, {
    key: "setSystemLastEventListnerWithLocation",
    value: function setSystemLastEventListnerWithLocation(location, systemLastEventListener) {
      log.trace("attach system last event listener with location!");
      this.firebaseSession.attachSystemLastEventListenerWithLocation(location, function (event) {
        log.trace("system event" + JSON.stringify(event));
        systemLastEventListener(event);
      });
    }
  }, {
    key: "getAPIUnreadConversationURL",
    value: function getAPIUnreadConversationURL() {
      return ChatManagerInstance.restApiURL + "/unreadConversations/" + this.userName;
    }
  }, {
    key: "getAPIUnreadItemsURL",
    value: function getAPIUnreadItemsURL() {
      return ChatManagerInstance.restApiURL + "/unreadItems/" + this.userName + "?includeThreads=" + BroadcastThreadManagerInstance.threadName;
    }
  }, {
    key: "getAPICensoredMessagesURL",
    value: function getAPICensoredMessagesURL() {
      return ChatManagerInstance.restApiURL + "/censoredMessages";
    }
  }, {
    key: "getNumberOfUnreadThreads",
    value: function getNumberOfUnreadThreads(getNumberOfUnreadThreadsHandler) {
      this.doGETRequest(this.getAPIUnreadConversationURL(), getNumberOfUnreadThreadsHandler);
    } // returns the number of unread conversations and the number of unread threads

  }, {
    key: "getNumberOfUnreadItems",
    value: function getNumberOfUnreadItems(getNumberOfUnreadItemsHandler) {
      this.doGETRequest(this.getAPIUnreadItemsURL(), getNumberOfUnreadItemsHandler);
    }
  }, {
    key: "checkForCensoredWords",
    value: function checkForCensoredWords(message, checkForCensoredWordsHandler) {
      this.doAPIRequest(this.getAPICensoredMessagesURL(), "POST", {
        message: message
      }, checkForCensoredWordsHandler);
    }
  }, {
    key: "detachGlobalRosterListener",
    value: function detachGlobalRosterListener() {
      this.firebaseSession.detachGlobalRosterListener();
    }
  }, {
    key: "detachGlobalRosterListenerWithLocation",
    value: function detachGlobalRosterListenerWithLocation(location) {
      this.firebaseSession.detachGlobalRosterListenerWithLocation(location);
    }
  }, {
    key: "detachGlobalEventsListener",
    value: function detachGlobalEventsListener() {
      this.firebaseSession.detachGlobalEventsListener();
    }
  }, {
    key: "detachSystemLastEventListener",
    value: function detachSystemLastEventListener() {
      this.firebaseSession.detachSystemLastEventListener();
    }
  }, {
    key: "detachSystemLastEventListenerWithLocation",
    value: function detachSystemLastEventListenerWithLocation(location) {
      this.firebaseSession.detachSystemLastEventListenerWithLocation(location);
    }
  }]);

  return GlobalPresenceSession;
}(BaseSession);

export { GlobalPresenceSession as default };